import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectMealTypeComponent } from './select-meal-type/select-meal-type.component';
import { MealFormService } from 'src/app/trip-calculator/services/meal-form.service';
import { PercentageComponent } from '../../custom-input/percentage/percentage.component';
import { PrestationModalService } from 'src/app/trip-calculator/services/prestation-modal.service';
import { ErrorComponent } from '../../error/error.component';

@Component({
  selector: 'app-meal-modal',
  imports: [
    SelectMealTypeComponent,
    ButtonModule,
    TranslocoPipe,
    ReactiveFormsModule,
    InputTextModule,
    CheckboxModule,
    InputNumberModule,
    PercentageComponent,
    ErrorComponent,
  ],
  templateUrl: './meal-modal.component.html',
})
export class MealModalComponent {
  mealFormService = inject(MealFormService);
  prestationModalService = inject(PrestationModalService);
  loading: boolean = false;

  submit() {
    this.loading = true;
    this.mealFormService.submitMeal()?.subscribe({
      next: () => {
        this.loading = false;
        this.close();
      },
      error: () => (this.loading = false),
    });
  }

  close() {
    this.prestationModalService.close();
    this.mealFormService.resetFormGroup();
  }

  get localAndSeasonalControl() {
    return this.mealFormService.mealForm.get('localSeasonalPercent') as FormControl;
  }

  get mealPercentageControl() {
    return this.mealFormService.mealForm.get('mealPercentage') as FormControl;
  }

  get typeControl() {
    return this.mealFormService.mealForm.get('type') as FormControl;
  }
}
